import { render } from "./GrammarlyProtocolForm.vue?vue&type=template&id=b19add1e&ts=true"
import script from "./GrammarlyProtocolForm.vue?vue&type=script&lang=ts"
export * from "./GrammarlyProtocolForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__